import React, { useEffect, useState } from "react";
import { SurgicalHistorydata } from "../../../AgencyFlow/AgencyScreens/Patientinfoeditscreens/Historydata";
import { GetSurgicalHistory } from "../../../../api/helper";

const SurgicalHistory = () => {
  const [ismedicalHistory, setismedicalHistory] = useState(false);

  const [SurgicalHistoryform, setSurgicalHistoryform] = useState({
    cardiovascularSurgeries: {
      aneurysmRepair: false,
      cabg: false,
      carotidEndarterectomy: false,
      pacemakerDefibrillator: false,
      ptcaPci: false,
    },
    commonSurgeries: {
      appendectomy: false,
      backSurgery: false,
      bariatricSurgery: false,
      bilateralTubalLigation: false,
      breastResectionMastectomy: false,
      carpalTunnelRelease: false,
    },
    ophthalmologySurgeries: {
      cataractLensSurgery: false,
      lasik: false,
    },
    gynecologicalSurgeries: {
      cesareanSection: false,
      dilationAndCurettage: false,
      hysterectomy: false,
      tahBso: false,
    },
    urologicalSurgeries: {
      prostateSurgery: false,
      prostatectomy: false,
      turp: false,
      vasectomy: false,
    },
    orthopedicSurgeries: {
      hipArthroplasty: false,
      hipReplacement: false,
      kneeArthroplasty: false,
      rotatorCuffSurgery: false,
      spinalFusion: false,
    },
    entSurgeries: {
      sinusSurgery: false,
      tonsillectomyAdenoidectomy: false,
      nasalSurgery: false,
    },
    skinCancerSurgeries: {
      skinCancerExcision: false,
      hemorrhoidSurgery: false,
    },
    miscellaneousSurgeries: {
      cholecystectomy: false,
      laminectomy: false,
      spinalFusion: false,
    },
  });

  const FetchSurgicalHistory = async () => {
    const agencyId = "680b1432319b16c8ea4c1dbf";
    const patientId = "681b328d561a4d17220aad65";
    try {
      const response = await GetSurgicalHistory(agencyId, patientId);
      const data = response?.data?.data;
      if (data && Object.keys(data).length > 0) {
        setSurgicalHistoryform({
          cardiovascularSurgeries: data.cardiovascularSurgeries || {},
          commonSurgeries: data.commonSurgeries || {},
          ophthalmologySurgeries: data.ophthalmologySurgeries || {},
          gynecologicalSurgeries: data.gynecologicalSurgeries || {},
          urologicalSurgeries: data.urologicalSurgeries || {},
          orthopedicSurgeries: data.orthopedicSurgeries || {},
          entSurgeries: data.entSurgeries || {},
          skinCancerSurgeries: data.skinCancerSurgeries || {},
          miscellaneousSurgeries: data.miscellaneousSurgeries || {},
        });
      }
    } catch (error) {
      console.log("Error fetching surgical history:", error);
    }
  };

  useEffect(() => {
    FetchSurgicalHistory();
  }, []);

  // ✅ Handle checkbox toggle
  const handleCheckboxChange = (category, key, checked) => {
    setSurgicalHistoryform((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: checked,
      },
    }));
  };

  // ✅ Collect all fields for summary
  const allFields = Object.values(SurgicalHistoryform).flatMap((section) =>
    Object.entries(section).filter(([key]) => !key.toLowerCase().includes("text"))
  );

  const trueFields = allFields.filter(([_, value]) => value === true);
  const falseFields = allFields.filter(([_, value]) => value === false);

  const displayedFields = [
    ...trueFields.slice(0, 5),
    ...falseFields.slice(0, 5 - trueFields.length),
  ];

  const renderSummary = (key, value) => (
    <div key={key} className="space_between" style={{ marginTop: 19 }}>
      <div className="smoking_txt1">
        {key.replace(/([A-Z])/g, " $1").toUpperCase()}
      </div>
      <div className="smoking_txt1">{value ? "YES" : "NO"}</div>
    </div>
  );

  return (
    <div className="Lifestyle_Determinants_chart1" style={{ marginLeft: 20 }}>
      <div className="Lifestyle_Determinants_div1">
        Surgical History
        <div onClick={() => setismedicalHistory(true)}>
          <img
            src={require("../../../assest/Images/pen_icon.png")}
            alt="Pen Icon"
          />
        </div>
      </div>

      {displayedFields.map(([key, value]) => renderSummary(key, value))}

      {ismedicalHistory && (
        <div className="modal_history" id="modal">
          <div className="modal-content_history">
            <div className="modal-header_history">
              <div className="modal-title flex items-center text-green-700 font-semibold text-lg mb-4">
                <span className="material-icons mr-2 text-green-500">🛠</span>
                Surgical History
              </div>

              <button
                className="close-btn_history"
                onClick={() => setismedicalHistory(false)}
              >
                &times;
              </button>
            </div>

            <div className="modal-body_history" id="modal-body">
              {SurgicalHistorydata.map(({ category, label, options }, index) => (
                <div className="category_history" key={index}>
                  <h4>{label}</h4>
                  {Object.entries(options).map(([key, optionLabel], i) => (
                    <div key={i} className="flex flex-col gap-1 mb-2">
                      <label className="flex items-center gap-2">
                        <input
                        disabled
                          type="checkbox"
                          checked={SurgicalHistoryform[category][key] || false}
                          onChange={(e) =>
                            handleCheckboxChange(category, key, e.target.checked)
                          }
                        />
                        {optionLabel}
                      </label>

                      {/* If you add "Other" options later */}
                      {key.toLowerCase().includes("other") &&
                        SurgicalHistoryform[category][key] && (
                          <input
                            type="text"
                            placeholder="Please specify"
                            className="border p-1 rounded w-full max-w-xs"
                            value={SurgicalHistoryform[category][`${key}Text`] || ""}
                            onChange={(e) =>
                              setSurgicalHistoryform((prev) => ({
                                ...prev,
                                [category]: {
                                  ...prev[category],
                                  [`${key}Text`]: e.target.value,
                                },
                              }))
                            }
                          />
                        )}
                    </div>
                  ))}
                </div>
              ))}
            </div>

            <div className="modal-footer_history">
              <button onClick={() => setismedicalHistory(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SurgicalHistory;
